import React, { Component } from "react";
import {
  NormalTable,
  NormalButtonBackend,
  NormalCheckbox,
} from "component/common";
import "./style.scss";
import { withTranslation } from "react-i18next";
import { getCommonApi, commonCreateApi } from "redux/actions/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BsArrowDownSquareFill } from "react-icons/bs";
import { Toast } from "service/toast";

export class InvoiceTempleteClass extends Component {
  state = {
    headerDetails: [
      { label: "Site Code" },
      { label: "Site Description" },
      {
        label: "All",
        width: "20px",
        selectAll: true,
        selectAllCheck: false,
        checkboxChange: (e) => this.handleSelectAllCheckbox(e),
      },
      { label: "Templete Name" },
      { label: "Download" },
    ],
    InvoiceList: "",
    selectedTemplete: null,
    selectedTableData: [],
    image: null,
  };

  componentDidMount() {
    this.customerOption();
  }

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  /* Select All Function */
  handleSelectAllCheckbox = () => {
    const { headerDetails, InvoiceList } = this.state;
    const selectAllCheck = headerDetails[2].selectAllCheck;
    let updatedSelectedTableData = [];
    if (!selectAllCheck) {
      updatedSelectedTableData = InvoiceList;
    }
    this.setState((prevState) => ({
      headerDetails: [
        ...prevState.headerDetails.slice(0, 2),
        {
          ...prevState.headerDetails[2],
          selectAllCheck: !prevState.headerDetails[2].selectAllCheck,
        },
        ...prevState.headerDetails.slice(3),
      ],
      selectedTableData: updatedSelectedTableData,
    }));
  };

  /* Customer Search Api */
  customerOption = () => {
    this.props.getCommonApi(`branchlist/`).then((res) => {
      let { data } = res;
      let { InvoiceList } = this.state;
      if (res.status === 200) {
        if (res.data) {
          this.setState({ InvoiceList: data });
        }
      }
    });
  };

  /* Select html file function */
  handleimageChange(event) {
    let { image } = this.state;
    const selectedFile = event.target.files[0];
    const allowedTypes = ["text/html"];
    if (selectedFile && allowedTypes.includes(selectedFile.type)) {
      image = URL.createObjectURL(selectedFile);
      this.setState({
        image,
        selectedTemplete: selectedFile,
      });
    } else {
      console.log("Invalid File Type. Please select an HTML file");
    }
  }

  /* Select MultipleData function */
  handleTableDataSelection = (item) => {
    const { selectedTableData } = this.state;
    const selectedIndex = selectedTableData.indexOf(item);

    if (selectedIndex === -1) {
      this.setState((prevState) => ({
        selectedTableData: [...prevState.selectedTableData, item],
      }));
    } else {
      this.setState((prevState) => ({
        selectedTableData: prevState.selectedTableData.filter(
          (data, index) => index !== selectedIndex
        ),
      }));
    }
    console.log(selectedTableData, "selectedTable");
  };

  /* upload file to api */
  // handleUpdate = () => {
  //   const { selectedTemplete, selectedTableData, InvoiceList } = this.state;
  //   const formData = new FormData();
  //   selectedTableData.forEach((item) => {
  //     formData.append("siteid", item.id);

  //     if (selectedTemplete) {
  //       formData.append("template_name", selectedTemplete.name);
  //       formData.append("file", selectedTemplete);
  //     } else {
  //       formData.append("template_name", item.inv_templatename);
  //     }
  //   });

  //   this.props
  //     .commonCreateApi("customerinvoicetemplateupload/", formData)
  //     .then((response) => {
  //       Toast({
  //         type: "success",
  //         message: "Updated Successfully",
  //       });
  //       /* Update the table with the selected template name */
  //       const updatedInvoiceList = InvoiceList.map((invoice) => {
  //         if (selectedTableData.some((item) => item.id === invoice.id)) {
  //           return {
  //             ...invoice,
  //             inv_templatename: selectedTemplete
  //               ? selectedTemplete.name
  //               : invoice.inv_templatename,
  //           };
  //         }
  //         return invoice;
  //       });

  //       this.setState({
  //         selectedTemplete,
  //         selectedTableData: [],
  //         InvoiceList: updatedInvoiceList,
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Update failed", error);
  //     });
  // };
  handleUpdate = () => {
    const { selectedTemplete, selectedTableData, InvoiceList } = this.state;

    const commonFormData = new FormData();
    commonFormData.append(
      "template_name",
      selectedTemplete ? selectedTemplete.name : ""
    );

    // Create an array to hold all the promises returned by the API calls
    const apiPromises = [];

    selectedTableData.forEach((item) => {
      const formData = new FormData();
      formData.append("siteid", item.id);

      if (selectedTemplete) {
        formData.append("file", selectedTemplete);
      } else {
        formData.append("template_name", item.inv_templatename);
      }

      // Append the common data to the individual formData
      for (const [key, value] of commonFormData.entries()) {
        formData.append(key, value);
      }

      // Push the API call promise to the array
      apiPromises.push(
        this.props.commonCreateApi("customerinvoicetemplateupload/", formData)
      );
    });

    // Wait for all the API calls to finish
    Promise.all(apiPromises)
      .then((responses) => {
        Toast({
          type: "success",
          message: "Updated Successfully",
        });

        /* Update the table with the selected template name */
        const updatedInvoiceList = InvoiceList.map((invoice) => {
          if (selectedTableData.some((item) => item.id === invoice.id)) {
            return {
              ...invoice,
              inv_templatename: selectedTemplete
                ? selectedTemplete.name
                : invoice.inv_templatename,
            };
          }
          return invoice;
        });

        this.setState({
          selectedTemplete: null,
          image: null,
          selectedTableData: [],
          InvoiceList: updatedInvoiceList,
        });
      })
      .catch((error) => {
        console.error("Update failed", error);
      });
  };

  downloadTemplate = (link) => {
    console.log(link, "Link");
    const item = link.inv_templatename;

    let data = {
      file: item,
    };

    this.props
      .commonCreateApi(`customerinvoicetemplatefiledownload/`, data)
      .then((res) => {
        console.log(res, "resPonse");
        const blob = new Blob([res], { type: "text/html" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "filename.html";
        a.click();

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.log(err, "downloadErr"));
  };

  render() {
    let {
      headerDetails,
      is_loading,
      pageMeta,
      InvoiceList,
      selectedTableData,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid division-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12 p-0">
                  <h4 className="label-head text-center text-md-left text-lg-left mt-5 mb-0">
                    {t("Customer Invoice Templete")}
                  </h4>
                </div>
                <div className="col-12">
                  <p className="label-title text-center text-md-left text-lg-left mt-3">
                    {t("Select HTML Templete")}
                  </p>
                </div>
                <div className="col-12 mt-3 d-flex justify-content-center justify-content-md-start justify-content-lg-start">
                  <input
                    type="file"
                    accept=".html"
                    onChange={(event) => this.handleimageChange(event)}
                  />
                </div>
              </div>
              <div className="tab-table-content">
                <div className="py-4">
                  <div className="table-container container-fluid">
                    <NormalTable
                      headerDetails={headerDetails}
                      pageMeta={pageMeta}
                      queryHandler={(event) => this.handlePageClick(event)}
                    >
                      {is_loading ? (
                        <tr>
                          <td colSpan="7">
                            <div class="d-flex mt-5 align-items-center justify-content-center">
                              <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : InvoiceList.length > 0 ? (
                        InvoiceList.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td>
                                <div className="text-left">
                                  {item.itemsite_code}
                                </div>
                              </td>
                              <td>
                                <div className="text-left">
                                  {item.itemsite_desc}
                                </div>
                              </td>
                              <td>
                                <div>
                                  <NormalCheckbox
                                    checked={selectedTableData.includes(item)}
                                    type="checkbox"
                                    name="selectAllCheck"
                                    onChange={() =>
                                      this.handleTableDataSelection(item)
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="text-left">
                                  {item.inv_templatename}
                                </div>
                              </td>
                              <td>
                                <div className="text-center cursor-pointer">
                                  <BsArrowDownSquareFill
                                    size={20}
                                    onClick={() => this.downloadTemplate(item)}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : null}
                    </NormalTable>
                  </div>
                </div>
              </div>
              <div className="mt-2 col-12 col-md-3 col-lg-3">
                <NormalButtonBackend
                  mainbg={true}
                  label="Upload"
                  onClick={this.handleUpdate}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
    },
    dispatch
  );
};

export const InvoiceTemplete = withTranslation()(
  connect(null, mapDispatchToProps)(InvoiceTempleteClass)
);
